import React, { useCallback, useEffect, useRef, useState } from "react";
import { API_URL, compareDates, LIMIT } from "../../config";
import swal from "sweetalert2";
import { strings } from "../../localization";
import KOTOrderList from "../../components/Restaurant/KOTOrderList";
import WebKOTOrderList from "../../components/Restaurant/WebKOTOrderList";
window.Swal = swal;

function CurrentKOTOrders({ isActive }) {
  const [loading, setLoading] = useState(true);
  const [records, setRecords] = useState([]);
  const [limit, setLimit] = useState(LIMIT);

  const config = {
    page_size: 100000,
    show_length_menu: false,
    show_info: false,
    show_pagination: false,
    button: {
      excel: false,
      print: false,
      extra: false,
    },
  };

  // refresh functionality states
  const intervalIdRef = useRef(null);
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  // auto refresh states
  const [lastUpdatedDate, setLastUpdatedData] = useState("");
  const lastUpdatedDateRef = useRef("");
  const loadingRef = useRef(false);

  useEffect(() => {
    lastUpdatedDateRef.current = lastUpdatedDate;
  }, [lastUpdatedDate]);

  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  const getCurrentKOTOrderList = (skip = 0) => {
    let statusCode = 0;
    const apiUrl = `${API_URL}web-restaurant-kot?status=in_queue,cooking,done&isOrderComplete=false`;
    console.log("api url of get queue kot orders", apiUrl);
    fetch(apiUrl, {
      method: "get",
      headers: {
        "Content-Type": "application/json",
      },
      credentials: "include",
    })
      .then((res) => {
        statusCode = res.status;
        console.log("status code of get kot orders", statusCode);
        return res.json();
      })
      .then((res) => {
        if (statusCode === 200) {
          const result = res["result"];
          const data = result["data"] ? result["data"] : [];
          let currentDate = result["lastUpdatedAt"]
            ? result["lastUpdatedAt"]
            : "";
          console.log(
            "🚀 ~ getCurrentKOTOrderList ~ currentDate:",
            currentDate
          );
          console.log(
            "lastUpdatedDate in function",
            lastUpdatedDateRef.current
          );
          if (compareDates(lastUpdatedDateRef.current, currentDate)) {
            console.log("compareDate function called now loading will be true");
            setLoading(true);
          }

          if (data && data.length > 0) {
            let orders = [];
            let groupedOrders = {};
            data.map((item, index) => {
              const orderData = item["data"];
              let dataArray = orderData["dataArray"]
                ? orderData["dataArray"]
                : [];

              const kotID = item["_id"];
              const kotDisplayID = orderData["kotID"];
              const tableDetail = orderData["tableDetail"];
              const orderDetail = orderData["orderDetail"];
              const orderDisplayID = orderDetail["orderID"];
              const orderID = orderData["restaurantOrderID"];
              const tableName = tableDetail ? tableDetail["tableName"] : "";

              if (!groupedOrders[orderDisplayID]) {
                groupedOrders[orderDisplayID] = [];
              }
              dataArray.map((foodItem, foodIndex) => {
                foodItem["kotID"] = kotID;
                foodItem["tableName"] = tableName;
                foodItem["kotDisplayID"] = kotDisplayID;
                foodItem["orderDisplayID"] = orderDisplayID;
                foodItem["orderID"] = orderID;
                // orders.push(foodItem);
                groupedOrders[orderDisplayID].push(foodItem);
              });
            });

            // Object.keys(groupedOrders).forEach((category) => {
            //   console.log('DEBUG category', category)
            //   // Add group header
            //   // Add group items
            //   orders.push({
            //     isGroup: true,
            //     category,
            //     orderId: category.orderID
            //   });
            //   groupedOrders[category].forEach((item) => {
            //     orders.push(item);
            //   });
            // });
            Object.entries(groupedOrders).map(
              ([categoryName, categoryData]) => {
                let orderId = "";
                if (Array.isArray(categoryData)) {
                  orderId = categoryData[0].orderID;
                }
                orders.push({
                  isGroup: true,
                  category: categoryName,
                  orderId,
                });
                if (Array.isArray(categoryData)) {
                  categoryData.forEach((item) => {
                    orders.push(item);
                  });
                }
              }
            );
            console.log("DEBUG current orders", orders);
            setRecords([...orders]);
            setLastUpdatedData(currentDate);
            setLoading(false);
          } else {
            setRecords([]);
            setLastUpdatedData("");
            setLoading(false);
          }
        } else {
          const msg = res["message"] ? res["message"] : "Something went wrong!";
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log("catch block error at get kot queue orders", err);
        setLoading(false);
      });
  };

  const getCurrentKOTOrderData = useCallback(() => {
    if (isActive) {
      getCurrentKOTOrderList();

      if (!isAlertVisible) {
        // Call the function every 5 seconds (5000 milliseconds)
        intervalIdRef.current = setInterval(getCurrentKOTOrderList, 5000);
      }
    }
  }, [isAlertVisible, isActive]);

  useEffect(() => {
    getCurrentKOTOrderData();
    return () => {
      clearInterval(intervalIdRef.current);
      intervalIdRef.current = null; // Reset interval ID
    };
  }, [getCurrentKOTOrderData, isActive]);

  useEffect(() => {
    if (isAlertVisible && intervalIdRef.current) {
      clearInterval(intervalIdRef.current); // Clear the interval when dialog is opened
    } else if (!isAlertVisible && intervalIdRef.current == null) {
      // Restart the interval when the dialog is closed and the tab is active
      intervalIdRef.current = setInterval(getCurrentKOTOrderList, 5000);
      return () => {
        clearInterval(intervalIdRef.current);
        if (intervalIdRef.current) {
          clearInterval(intervalIdRef.current);
        }
      };
    }
  }, [isAlertVisible, intervalIdRef.current]);

  const handleStatus = (kotID, itemID, isFromCooking) => {
    setIsAlertVisible(true);
    swal
      .fire({
        title: isFromCooking
          ? strings.complete_item_title
          : strings.accept_item_title,
        text: isFromCooking ? strings.complete_item : strings.accept_item,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2E209D",
        cancelButtonColor: "#D61E11",
        confirmButtonText: strings.yes,
        cancelButtonText: strings.no,
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          const apiUrl = `${API_URL}web-restaurant-kot/${kotID}/item/${itemID}?status=${isFromCooking ? "done" : "cooking"
            }`;
          console.log("api url of update kot item status", apiUrl);
          // const bodyData = JSON.stringify({
          //   status: isFromCooking ? "done" : "cooking",
          // });

          // console.log("bodyData of kot status update api", bodyData);
          return fetch(apiUrl, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
            // body: bodyData,
          })
            .then((res) => {
              console.log("response of update status api", res);
              const title = isFromCooking
                ? strings.completed
                : strings.accepted;
              const message = isFromCooking
                ? strings.item_complete_msg
                : strings.item_accept_msg;
              if (res.status === 200) {
                swal.fire(title, message, "success");
                setLoading(true);
                setIsAlertVisible(false);
                getCurrentKOTOrderList();
              } else {
                swal.showValidationMessage(`Something went wrong!`);
              }
              return res.json();
            })
            .catch((err) => {
              swal.showValidationMessage(`Request failed: ${err}`);
              setIsAlertVisible(false);
            });
        },
      })
      .then((result) => {
        console.log("result of update status", result);
        setIsAlertVisible(false);
      });
  };

  const handleOrderStatus = (record) => {
    console.log("record", record);
    setIsAlertVisible(true);
    swal
      .fire({
        title: strings.complete_order_title,
        text: strings.complete_order_msg,
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#2E209D",
        cancelButtonColor: "#D61E11",
        confirmButtonText: strings.yes,
        cancelButtonText: strings.no,
        showLoaderOnConfirm: true,
        preConfirm: (login) => {
          const orderID = record.orderId;
          const apiUrl = `${API_URL}web-restaurant-order-complete/${orderID}`;
          console.log("api url of complete order", apiUrl);

          return fetch(apiUrl, {
            method: "PATCH",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          })
            .then((res) => {
              console.log("response of order complete api", res);
              const title = strings.completed;
              const message = strings.succes_order_completed;
              if (res.status === 200) {
                swal.fire(title, message, "success");
                setLoading(true);
                setIsAlertVisible(false);
                getCurrentKOTOrderList();
              } else {
                swal.showValidationMessage(`Something went wrong!`);
              }
              return res.json();
            })
            .catch((err) => {
              swal.showValidationMessage(`Request failed: ${err}`);
              setIsAlertVisible(false);
            });
        },
      })
      .then((result) => {
        console.log("result of update status", result);
        setIsAlertVisible(false);
      });
  };

  return (
    <>
      <WebKOTOrderList
        loading={loadingRef.current}
        records={records}
        limit={limit}
        config={config}
        handleStatus={handleStatus}
        isCurrentOrders
        handleOrderStatus={handleOrderStatus}
      />
    </>
  );
}
export default CurrentKOTOrders;
